import styled from "styled-components";
import { siteDarkBlue, siteGray } from "../../providers/Theme";

export const Section = styled.section`
  background: white;
  padding: 4rem 1.5rem;
  position: relative;
  z-index: 0;
`;

export const SectionHeading = styled.h2<{ $uppercase?: boolean }>`
  color: ${siteDarkBlue};
  font-weight: 800;
  font-size: 2rem;
  text-transform: ${({ $uppercase }) => ($uppercase === false ? "none" : "uppercase")};
  letter-spacing: ${({ $uppercase }) => ($uppercase === false ? "normal" : "0.05em")};
  text-align: center;
  line-height: 1.25;
  margin-bottom: 2.5rem;

  ${({ theme }) => theme.md`
    font-size: 2.5rem;
  `}
`;

export const HeadingAccent = styled.span`
  color: ${siteDarkBlue};
`;

export const LogoStrip = styled.div`
  max-width: 72rem;
  margin: 0 auto;
  background: ${siteGray};
  border-radius: 12px;
  padding: 2rem 0.5rem;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const Track = styled.div`
  flex: 1;
  display: flex;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const LogoCell = styled.a`
  scroll-snap-align: start;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.25rem;
  flex-shrink: 0;
  text-decoration: none;

  img {
    max-height: 72px;
    max-width: 100%;
    width: auto;
    object-fit: contain;
  }
`;

export const CarouselCaption = styled.p`
  text-align: center;
  color: #555;
  font-size: 1.25rem;
  margin-top: 1.5rem;
`;

export const NavButton = styled.button`
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: ${siteDarkBlue};
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.15s ease;

  &:hover {
    background: #d8dbde;
  }
`;
